//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from '@/store'
import { getConfig, addFile } from '@/api/wx.js'
import { getZbConfig, addZb, getZbAll } from '@/api/zhigongxiaojia.js'
export default {
  name: 'test2',
  props: {},
  data () {
    return {
      list: []
    }
  },
  created () {
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    var element = document.createElement('script')
    element.src = 'http://res.wx.qq.com/open/js/jweixin-1.2.0.js'
    document.body.appendChild(element)
    var element2 = document.createElement('script')
    element2.src = 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'
    document.body.appendChild(element2)
    setTimeout(() => {
      this.wxconfig()
    }, 1000)
    this.getZb()
  },
  methods: {
    getZb () {
      getZbAll({}).then(res => {
        this.list = res.obj
      })
    },
    wxconfig () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = store.state.user.wechatSignUrl
        // alert('微信客户端')
      }

      getZbConfig({
        url: href
      }).then(res => {
        // wx.config({
        //   beta: true,
        //   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        //   appId: res.corpid, // 必填，公众号的唯一标识
        //   timestamp: res.timestamp, // 必填，生成签名的时间戳
        //   nonceStr: res.nonceStr, // 必填，生成签名的随机串
        //   signature: res.signature, // 必填，签名，见附录1
        //   jsApiList: ['agentConfig'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        // })
        // wx.ready(function () {
        console.log('wx', wx)
        wx.agentConfig({
          // debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          corpid: res.obj.corpid, // 必填，公众号的唯一标识
          agentid: res.obj.agentid,
          timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
          signature: res.obj.signature, // 必填，签名，见附录1
          jsApiList: ['startLiving'], // 必填，传入需要使用的接口名称
          success: function (res) {
            // 回调
            console.log('agentconfigsuc', res)
          },
          fail: function (res) {
            console.log('agentconfigerr', res)
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })
        // wx.invoke('startLiving', {
        //   'liveType': 1,
        //   'theme': '新同学培训'
        // }, function (res) {
        //   console.log('invoke', res)
        //   if (res.err_msg == 'startLiving:ok') {
        //     let livingId = res.livingId
        //     console.log(livingId)
        //   }
        // })
      })
      // })
      // })
    },
    wxconfig2 () {
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getConfig({
        url: href
      }).then(re => {
        var configs = re.returnValue
        wx.config({
          beta: true,
          debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configs.appId, // 必填，公众号的唯一标识
          timestamp: configs.timestamp, // 必填，生成签名的时间戳
          nonceStr: configs.nonceStr, // 必填，生成签名的随机串
          signature: configs.signature, // 必填，签名，见附录1
          jsApiList: ['agentConfig'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          getZbConfig({
            url: href
          }).then(res => {
            console.log('wx', wx)
            wx.agentConfig({
              corpid: res.obj.corpid, // 必填，公众号的唯一标识
              agentid: res.obj.agentid,
              timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
              signature: res.obj.signature, // 必填，签名，见附录1
              jsApiList: ['startLiving'], // 必填，传入需要使用的接口名称
              success: function (res) {
                // 回调
                console.log('agentconfigsuc', res)
              },
              fail: function (res) {
                console.log('agentconfigerr', res)
                if (res.errMsg.indexOf('function not exist') > -1) {
                  alert('版本过低请升级')
                }
              }
            })
          })
        })
      })
    },
    create () {
      wx.invoke('startLiving', {
        'liveType': 1,
        'theme': '新同学培训'
      }, function (res) {
        console.log(res)
        if (res.err_msg == 'startLiving:ok') {
          let livingId = res.livingId
          console.log(livingId)
          console.log(res)
          addZb({
            accountid: 123123,
            title: '新同学培训',
            livingId: livingId
          })
        }
      })
    },
    join (id) {
      wx.invoke('startLiving', {
        'livingId': id
      }, function (res) {
        if (res.err_msg == 'startLiving:ok') {
          // livingId = res.livingId
        }
      })
    }
  }
}
